export default __webpack_public_path__ + "static/media/Armbands of the Whispering Blade.2be2227f.jpg";